import type { QueryClient } from '@tanstack/react-query';
import { createRouter, type RouterHistory } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';

export type CreateAppRouterOptions = {
  /** Historique mémoire pour les tests ; navigateur par défaut. */
  history?: RouterHistory | undefined;
};

/** `main.tsx` crée le `QueryClient` et l'injecte ici : pas de singleton partagé entre modules. */
export function createAppRouter(queryClient: QueryClient, options: CreateAppRouterOptions = {}) {
  return createRouter({
    routeTree,
    context: { queryClient },
    defaultPreload: 'intent',
    // Les données viennent de TanStack Query : le router ne les met pas en cache lui-même.
    defaultPreloadStaleTime: 0,
    scrollRestoration: true,
    ...(options.history ? { history: options.history } : {}),
  });
}

export type AppRouter = ReturnType<typeof createAppRouter>;

declare module '@tanstack/react-router' {
  interface Register {
    router: AppRouter;
  }
}
